import React, { FC } from 'react';
import { Tag } from '@duxton-web/ui';
import { TagProps } from '@duxton-web/ui/lib/tag';

import { getTenant } from '../Tenants';
import {
  getAppOptionsMap,
  isValidAppVersion,
  osOptionsMap,
  parseAppVersion,
} from './appVersionUtils';

interface AppVersionTagProps {
  value: string;
  disabled?: boolean;
  onClick?: () => void;
  onClose?: () => void;
}

const AppVersionTag: FC<AppVersionTagProps> = ({
  value,
  disabled,
  onClick,
  onClose,
}) => {
  const [app, os, version] = parseAppVersion(value);
  const hasError = !isValidAppVersion(value);
  const appOptionsMap = getAppOptionsMap(getTenant());

  let tagProps: TagProps = {
    color: hasError ? 'red' : '',
  };

  let tagClickHandler: () => void;

  if (!disabled) {
    tagProps = {
      ...tagProps,
      onClose,
      closable: true,
      style: { cursor: 'text' },
    };
    tagClickHandler = onClick;
  }

  return (
    <Tag {...tagProps} size="xsmall">
      <span onClick={tagClickHandler}>
        {hasError
          ? value
          : `${appOptionsMap[app]}-${osOptionsMap[os]}-${version}`}
      </span>
    </Tag>
  );
};

export default AppVersionTag;
